import { OrderType } from './Order'

export type ApplyDiscountRequest = {
  code?: string
  clientEmail?: string
  orderType: OrderType
}

export enum DiscountTypes {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
  FREE_SHIPPING = 'FREE_SHIPPING',
  DIRECT = 'DIRECT',
}

export type Discount = {
  discountId: string
  type: DiscountTypes
  amount: number
  isRecurrent: boolean
  code: string
  isActive: boolean
  channel: string
  tags: string[]
  isDefault: boolean
  subscriptionChargeLimit?: number
}

export const BLACK_FRIDAY_DISCOUNT_CODE = 'BLACKFRIDAY100'
